import { Locale } from "../../types/i18n"

export default (locale: Locale) => (format: keyof Locale["days"]) => (date: Date) => locale.days[format][date.getDay()]
